import styled from '@emotion/styled';

export const SadaServiceStepFormModal = styled.div``;
